import React, { useContext, useEffect, useState } from 'react';

import CardBaseFC, { RoundNotLoadedYet } from 'components/CardBase/index.js';
import { MobileContext } from 'context/index.js';
import { availablePositions } from 'const';
import { FormattedPrice } from 'utils/Price/index.js';
import { useCurrentRound, useNextRound, useUserBetForRoundID } from 'utils/Hooks';
import CurrentPrice from './price.js';
import { ReactComponent as BullIcon } from 'assets/icons/BullIconNew.svg';
import { ReactComponent as BearIcon } from 'assets/icons/BearIcon.svg';
import { ReactComponent as Padlock } from 'assets/icons/Padlock.svg';
import './index.scss';
import useTimestampNow from 'utils/Hooks/useTime.js';


function CardCurrent(props) {
  const isMobile = useContext(MobileContext)

  const roundCurrent = useCurrentRound();
  const roundNext = useNextRound();
  const userBetData = useUserBetForRoundID(roundCurrent.epoch);

  //const timeNowMs = useTimestampNow();
  const timeNowMs_native = Date.now();

  const [roundIsEntered, SetWhetherRoundIsEntered] = useState(false);
  const [glowCSSEffects, SetGlowEffects] = useState({});

/*
  useEffect(() => {
    // DEBUG
    //console.log(`timeNowMs: ${(timeNowMs/1000).toFixed()} vs ${(timeNowMs_native/1000).toFixed()}`);
  }, [timeNowMs]);
  */

  useEffect(() => {
    if (!roundIsEntered) {
      const userEnteredThisRound = (userBetData?.amount > 0);
      SetWhetherRoundIsEntered(userEnteredThisRound);
    }
  }, [userBetData])


  function ActivateGlow(priceAction) {
    if (!priceAction) throw new SyntaxError('Missing required argument: priceAction');
    let glowColor;
    switch (priceAction) {
      case 'bear':
        glowColor = "var(--color-glow-red)";
        //glowColor = "var(--color-bear-red)";
        break;
      case 'bull':
        //glowColor = "var(--color-glow-green)";
        glowColor = "var(--color-bull-green)";
        break;
      case 'neutral':
        glowColor = "var(--color-glow-white)";
        break;
      default:
        glowColor = "var(--color-glow-white)";
        break;
    }
    const glowStyle = { boxShadow: '0 0 25px ' + glowColor };
    SetGlowEffects(glowStyle)
  }


  function RoundExpired_next() {
    if (RoundNotLoadedYet(roundNext))
      return false;
    else if (roundNext.lockTimestamp * 1000 < timeNowMs_native)
      return true;
    else
      return false;
  }

  function RoundExpired_current() {
    if (RoundNotLoadedYet(roundCurrent))
      return false;
    else if (roundCurrent.closeTimestamp * 1000 < timeNowMs_native)
      return true;
    else
      return false;
  }

  const RoundExpired = RoundExpired_current; // use this round's close time(versus next round's lock time) as the expiry time

  function Payout(side) {
    let output, styles = {};
    if (RoundNotLoadedYet(roundCurrent)) {
      output = null;
    } else {
      const round = roundCurrent;
      const rewards = Number(round.bullAmount) + Number(round.bearAmount);
      let wantedSideTotalBet, payout;
      if (side === 'bear') {
        styles.color = 'var(--color-bear-red)';
        wantedSideTotalBet = Number(round.bearAmount);
      } else if (side === 'bull') {
        styles.color = 'var(--color-bull-green)';
        wantedSideTotalBet = Number(round.bullAmount);
      } else {
        throw new SyntaxError('missing "side" argument in "Payout" function in "CardCurrent" class');
      }

      if (wantedSideTotalBet === 0)
        payout = '0.00'
      else
        payout = (rewards / wantedSideTotalBet).toFixed(2);
      output = <p id='CurrentCardPayoutFigure' style={styles}>{payout}x </p>;
    }
    return output;
  }


  function ShowEntryNoticeForSide(side) {
    if (!side) throw new SyntaxError('missing required argument: side');
    if (UserMadeBetOnThisSide(side))
      return 'block';
    else
      return 'none';
  }

  function UserMadeBetOnThisSide(side) {
    if (!side) throw new SyntaxError('missing required argument: side');
    else if (side != 'bear' && side != 'bull')
      throw new SyntaxError('malformed argument: side; only "bear" or "bull" values are permitted');

    /*
    if (side === 'bull') // debug
      return true; // debug
    */

    if (roundIsEntered) {
      const userPosition = Number(userBetData.position);
      if (userPosition === availablePositions.bull && side === 'bull')
        return true;
      else if (userPosition === availablePositions.bear && side === 'bear')
        return true;
      return false;
    }
  }

  function Rewards() {
    return (
      <div className='Prizes'>
        <p>Payouts</p>
        <div className={'Sides' + (isMobile ? ' Mobile' : '')}>

          <div className='SideWrapper'>
            <div className='ThemeBox Side'>
              {/*
              <TextEntered className='EntryNotice Bull'
                style={{ display: ShowEntryNoticeForSide('bull') }}
              />
              */}
              <BullIcon className='Icon Bull' />
              {Payout("bull")}
            </div>
            <p className='EntryNotice Bull' style={{ display: ShowEntryNoticeForSide('bull') }}>
              your bet
            </p>
          </div>

          <div className='SideWrapper'>
            <div className='ThemeBox Side'>
              {/*
              <TextEntered className='EntryNotice Bear'
                style={{ display: this.ShowEntryNoticeForSide('bear') }}
              />
              */}
              <BearIcon className='Icon Bear' />
              {Payout("bear")}
            </div>
            <p className='EntryNotice Bear' style={{ display: ShowEntryNoticeForSide('bear') }}>
              your bet
            </p>
          </div>

        </div>
      </div>);
  }


  function LockPrice() {
    let output;
    if (RoundNotLoadedYet(roundCurrent)) {
      output = null;
    } else {
      const price = Number(roundCurrent.lockPrice) / 10 ** 8;
      output = (<div>
        <div className='ThemeBox' id='LockedPrice'>
          <p>Start price:</p>
          <p>
            {/* <Padlock id='Padlock' /> */}
            <FormattedPrice price={price} /> USDT
          </p>
        </div>
        <div className='Separator' />
      </div>);
    }
    return output;
  }

  function Timer() {
    if (RoundNotLoadedYet(roundCurrent)) return null;
    else if (isMobile)
      return (
        <div>
          <Timer
            targetTimestamp={roundCurrent.closeTimestamp}
            roundDuration={roundCurrent.closeTimestamp - roundCurrent.lockTimestamp}
            ongoingMessage="Ends"
            endedMessage="Ended"
            showImage={false}
          />
        </div>
      );
    else return null;
  }


  return (
    <CardBaseFC
      cardName='Ongoing'
      additionalCssStyles='Glow'
      style={glowCSSEffects}
      round={roundCurrent}
    >
      {/* ExecutionNotice() */}
      <div id='CardCurrentBody' style={RoundExpired() ? { display: 'none' } : {}}>
        <CurrentPrice
          lockPrice={roundCurrent?.lockPrice}
          markedLoaded={props.markedLoaded}
          OnLoad={props.OnLoad}
          OnBearAction={() => ActivateGlow('bear')}
          OnBullAction={() => ActivateGlow('bull')}
          OnNeutralAction={() => ActivateGlow('neutral')}
        />
        {LockPrice()}
        {Rewards()}
      </div>
    </CardBaseFC>
  );
}

export default CardCurrent;
